import Layout from '@/layout' // Layout 是架构组件，不在后台返回，在文件里单独引入
import router from './index.js'
import store from '../store/index.js'
let arr = [
  {
    path: '/systems',
    alias: '/',
    component: Layout,
    meta: { title: '系统设置', icon: 'dashboard' },
    children: [
      {
        path: '/systems/params',
        component: () => import('@/views/systems/params'),
        meta: { title: '机构设置', icon: 'dashboard' }
      },
      {
        path: '/systems/edit',
        component: () => import('@/views/systems/edit'),
        meta: { title: '系统参数设置', icon: 'dashboard' }
      },
      {
        path: '/systems/record',
        component: () => import('@/views/systems/record'),
        meta: { title: '操作日志', icon: 'dashboard' }
      }
    ]
  },
  {
    path: '/competitionManage',
    component: Layout,
    meta: { title: '比赛管理', icon: 'dashboard' },
    children: [
      {
        path: '/competitionManage/scoreManage',
        component: () => import('@/views/competitionManage/scoreManage/scoreManage'),
        meta: { title: '成绩管理', icon: 'dashboard' }
      },
      {
        path: '/competitionManage/testPaperManage',
        component: () => import('@/views/competitionManage/testPaperManage/index'),
        meta: { title: '试题管理', icon: 'dashboard' }
      }
    ]
  },
  {
    path: '/rotationManage',
    component: Layout,
    meta: { title: '轮转管理', icon: 'dashboard' },
    children: [
      {
        path: '/rotationManage/orgManage',
        component: () => import('@/views/rotationManage/orgManage/index'),
        meta: { title: '轮转学员', icon: 'dashboard' }
      },
      {
        path: '/rotationManage/orgManage',
        component: () => import('@/views/rotationManage/rotationModel/index'),
        meta: { title: '轮转模板', icon: 'dashboard' }
      },
      {
        path: '/rotationManage/rotatingTextbooks',
        component: () => import('@/views/rotationManage/rotatingTextbooks/index'),
        meta: { title: '轮转教材', icon: 'dashboard' }
      },
      {
        path: '/rotationManage/rotatingPaper',
        component: () => import('@/views/rotationManage/rotatingPaper/index'),
        meta: { title: '轮转考卷', icon: 'dashboard' }
      }
    ]
  },
  {
    path: '/role',
    component: Layout,
    meta: { title: '角色管理', icon: 'dashboard' },
    children: [
      {
        path: '/role/index',
        component: () => import('@/views/roleManagement/roles/list'),
        meta: { title: '角色一览', icon: 'dashboard' }
      },
      {
        path: '/role/module',
        component: () => import('@/views/roleManagement/modules/index'),
        meta: { title: '角色模板', icon: 'dashboard' }
      },
      {
        path: '/rolesHomePage',
        ishidden: true,
        component: () => import('@/views/roleManagement/roles/rolesHomePage')
      }
    ]
  },
  {
    path: '/questionManage',
    component: Layout,
    meta: { title: '题库管理', icon: 'dashboard' },
    children: [
      {
        path: '/questionManage/index',
        component: () => import('@/views/questionManagement/questionManage/index.vue'),
        meta: { title: '题库一览', icon: 'dashboard' }
      }
    ]
  },
  {
    path: '/websiteManagement',
    component: Layout,
    meta: { title: '官网管理', icon: 'dashboard' },
    children: [
      {
        path: '/websiteManagement/parameterSet',
        ishidden: true,
        component: () => import('@/views/websiteManagement/parameterSet.vue'),
        meta: { title: '参数设置', icon: 'dashboard', activeMenu: '/websiteManagement/parameterSet' }
      },
      {
        path: '/websiteManagement/coreUnit',
        ishidden: true,
        component: () => import('@/views/websiteManagement/coreUnit/index.vue'),
        meta: { title: '核心单位', icon: 'dashboard', activeMenu: '/websiteManagement/coreUnit' }
      },
      {
        path: '/websiteManagement/coreTeam',
        ishidden: true,
        component: () => import('@/views/websiteManagement/coreTeam/index.vue'),
        meta: { title: '核心团队', icon: 'dashboard', activeMenu: '/websiteManagement/coreTeam' }
      },
      {
        path: '/websiteManagement/processTeach',
        ishidden: true,
        component: () => import('@/views/websiteManagement/processTeach/index.vue'),
        meta: { title: '过程化教学案例', icon: 'dashboard', activeMenu: '/websiteManagement/coreTeam' }
      },
      {
        path: '/websiteManagement/bigEvents',
        ishidden: true,
        component: () => import('@/views/websiteManagement/bigEvents/index.vue'),
        meta: { title: '过程化教学案例', icon: 'dashboard', activeMenu: '/websiteManagement/bigEvents' }
      }
    ]
  },
  {
    path: '/studentManagement',
    alias: '/',
    component: Layout,
    meta: { title: '学生管理', icon: 'dashboard' },
    children: [
      {
        path: '/studentManagement/studentList',
        component: () => import('@/views/studentManagement/studentList.vue'),
        meta: { title: '学生一览', icon: 'dashboard' }
      }
    ]
  },
  {
    path: '/textbooks',
    alias: '/',
    component: Layout,
    meta: { title: '考试管理', icon: 'dashboard' },
    children: [
      {
        path: '/textbooks/management',
        component: () => import('@/views/textbooks/management.vue'),
        meta: { title: '教材一览', icon: 'dashboard' }
      },
      {
        path: '/textPaper/teachManagement',
        component: () => import('@/views/textPaper/teachManagement.vue'),
        meta: { title: '考卷一览', icon: 'dashboard' }
      },
      {
        path: '/examManagement/examList',
        component: () => import('@/views/examManagement/examList.vue'),
        meta: { title: '成绩管理', icon: 'dashboard' }
      },
      {
        path: '/textSet/textSet',
        component: () => import('@/views/textSet/textSet.vue'),
        meta: { title: '考试设置', icon: 'dashboard' }
      }
    ]
  }
]
let arr1 = [
  {
    path: '/questionManage',
    component: Layout,
    meta: { title: '题库管理', icon: 'dashboard' },
    children: [
      {
        path: 'index',
        component: () => import('@/views/questionManagement/questionManage/index.vue'),
        meta: { title: '题库一览', icon: 'dashboard' }
      }
    ]
  }
]
function filterAsyncRouter (asyncRouterMap) { // 遍历后台传来的路由字符串，转换为组件对象
  const accessedRouters = asyncRouterMap.filter(route => {
    route.path = route.url;
    if (route.childEntity && route.childEntity.length) {
      route.meta = { title: route.name, icon: route.menuIco }
    } else {
      route.meta = { title: route.name, icon: 'arrow-right', code: route.code }
    }
    if (!route.component) {
      if (route.resourceId === 'Layout') { // Layout组件特殊处理
        route.component = Layout
      } else {
        // route.component =   require('@/components' + route.resourceId)
        let component = resolve => require.ensure([], () => resolve(require('@/views' + route.resourceId)))
        route.component = component;
      }
    }
    if (route.childEntity && route.childEntity.length) {
      route.children = filterAsyncRouter(route.childEntity)
    }
    return true
  })
  return accessedRouters
}

function routerGo (to, next, list) {
  // console.log(JSON.stringify(list))
  let getRouter = filterAsyncRouter(list) // 过滤路由
  console.log(getRouter, 'getRouter')
  // let getRouter=list;
  router.addRoutes(getRouter) // 动态添加路由
  router.addRoutes([{ path: '*', component: () => import('@/components/common/404'), redirect: '/404', hidden: true }]) // 404 page must be placed at the end !!!
  store.commit('updateRoutes', { routes: getRouter }) // 将路由数据传递，做侧边栏菜单渲染工作
  next({
    ...to,
    replace: true
  })
}

function getObjArr (name) { // localStorage 获取数组对象的方法
  return window.localStorage.getItem(name) && window.localStorage.getItem(name).constructor === Object ? JSON.parse(window.localStorage.getItem(name)) : null;
}

export {
  routerGo,
  getObjArr,
  arr,
  arr1
}



// WEBPACK FOOTER //
// ./src/router/import_router.js